/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TableRowVisibilityConditionDto } from './TableRowVisibilityConditionDto';
import {
    TableRowVisibilityConditionDtoFromJSON,
    TableRowVisibilityConditionDtoFromJSONTyped,
    TableRowVisibilityConditionDtoToJSON,
    TableRowVisibilityConditionDtoToJSONTyped,
} from './TableRowVisibilityConditionDto';

/**
 * A single advisory note shown on a cell when `conditions` hold for that row.
 * @export
 * @interface TableCellAdvisoryDto
 */
export interface TableCellAdvisoryDto {
    /**
     * Visual weight of the note. Defaults to WARNING when unset.
     * @type {string}
     * @memberof TableCellAdvisoryDto
     */
    severity?: TableCellAdvisoryDtoSeverityEnum;
    /**
     * The note shown beneath the cell's input. Plain text, already localized.
     * @type {string}
     * @memberof TableCellAdvisoryDto
     */
    message?: string;
    /**
     * 
     * @type {TableRowVisibilityConditionDto}
     * @memberof TableCellAdvisoryDto
     */
    conditions?: TableRowVisibilityConditionDto;
}


/**
 * @export
 */
export const TableCellAdvisoryDtoSeverityEnum = {
    Warning: 'WARNING',
    Info: 'INFO'
} as const;
export type TableCellAdvisoryDtoSeverityEnum = typeof TableCellAdvisoryDtoSeverityEnum[keyof typeof TableCellAdvisoryDtoSeverityEnum];


/**
 * Check if a given object implements the TableCellAdvisoryDto interface.
 */
export function instanceOfTableCellAdvisoryDto(value: object): value is TableCellAdvisoryDto {
    return true;
}

export function TableCellAdvisoryDtoFromJSON(json: any): TableCellAdvisoryDto {
    return TableCellAdvisoryDtoFromJSONTyped(json, false);
}

export function TableCellAdvisoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TableCellAdvisoryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'severity': json['severity'] == null ? undefined : json['severity'],
        'message': json['message'] == null ? undefined : json['message'],
        'conditions': json['conditions'] == null ? undefined : TableRowVisibilityConditionDtoFromJSON(json['conditions']),
    };
}

export function TableCellAdvisoryDtoToJSON(json: any): TableCellAdvisoryDto {
    return TableCellAdvisoryDtoToJSONTyped(json, false);
}

export function TableCellAdvisoryDtoToJSONTyped(value?: TableCellAdvisoryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'severity': value['severity'],
        'message': value['message'],
        'conditions': TableRowVisibilityConditionDtoToJSON(value['conditions']),
    };
}

